import * as React from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';

const TabsWrapper = styled<any, any>('nav')`
    ${propStyles};
`;

TabsWrapper.defaultProps = {
    display: 'flex',
    flex: '1 0 auto',
    flexWrap: 'wrap',
    borderWidth: '1px',
    borderStyle: 'none none solid none',
    borderColor: 'gray300',
};

@observer
class Tabs extends React.Component<any> {
    render() {
        const { theme, children, ...props } = this.props;
        return (
            <TabsWrapper {...theme.TabsWrapper} {...props}>
                {children}
            </TabsWrapper>
        );
    }
}

export default withTheme(Tabs) as any;



// WEBPACK FOOTER //
// ./src/Components/Tabs.tsx